/**
 * Enum of search types used by the API.
 */
export enum SearchType {
  FieldSearch = 'fieldSearch',
  Query = 'query'
}
